import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=54e1c02f&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=54e1c02f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1c02f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e1c02f')) {
      api.createRecord('54e1c02f', component.options)
    } else {
      api.reload('54e1c02f', component.options)
    }
    module.hot.accept("./bindPhone.vue?vue&type=template&id=54e1c02f&scoped=true&", function () {
      api.rerender('54e1c02f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/bindPhone.vue"
export default component.exports